import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { E2eePayload } from 'STORE/Messages/Message/Payload/E2eePayload/E2eePayload';

import { CommonPayload } from '../CommonPayload/CommonPayload';

interface IE2eePayloadProps {
  name: string | null;
  payload: E2eePayload;
}

export const GroupDescriptionE2eePayload: FC<IE2eePayloadProps> = observer(({ name, payload }) => {
  return (
    <CommonPayload
      Icon={null}
      name={name}
      description={payload?.text}
    />
  );
});
